import { computed, watch } from 'vue';

import { useCartStore } from '@/stores/cart';
import { EMBED_CART_UPDATE } from '@/utils/embedMessageTypes';
import { isEmbed } from '@/utils/isEmbed';

export function useEmbedCartSync(): void {
  if (!isEmbed()) return;

  const cartStore = useCartStore();
  const totalCartCount = computed(() =>
    cartStore.receiptCart ? 0 : cartStore.items.reduce((sum, item) => sum + item.tickets.reduce((s, t) => s + t.count, 0), 0)
  );

  watch(
    totalCartCount,
    (count) => {
      if (import.meta.env.DEV) console.log('[Safeticket Embed] sending cart count:', count);
      window.parent.postMessage({ type: EMBED_CART_UPDATE, count }, '*');
    },
    { immediate: true }
  );
}
